function Label(props) {
    return null;
}
Label.displayName = 'Label';
export default Label;
//# sourceMappingURL=Label.js.map